module.exports = __webpack_public_path__ + "static/media/simplicity.b98514ce.svg";